import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=51cedd5c&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51cedd5c')) {
      api.createRecord('51cedd5c', component.options)
    } else {
      api.reload('51cedd5c', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=51cedd5c&", function () {
      api.rerender('51cedd5c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-23Q6IZHfpWu1g/JS/offershelp.vue"
export default component.exports